var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82 4.99624L6.11 1.70378C6.5 1.31348 6.5 0.683012 6.11 0.292719C5.72 -0.0975731 5.09 -0.0975731 4.7 0.292719C3.13333 1.86056 1.56667 3.4284 0 4.99624C1.56667 6.56409 3.13333 8.13193 4.7 9.69977C4.9 9.89992 5.15 9.99999 5.41 9.99999C5.67 9.99999 5.92 9.89992 6.12 9.70978C6.51 9.31948 6.51 8.68901 6.12 8.29872L2.82 4.99624Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageArrow);
export default __webpack_public_path__ + "static/media/pageArrow.d886d87ecf085f5707a6be96aff33f41.svg";
export { ForwardRef as ReactComponent };